import React, { Fragment } from 'react';
import moment from 'moment';
import ReactTable from 'react-table';
import { BeatLoader } from 'react-spinners';
import NotificationSystem from 'react-notification-system';
import { get, postWithHeaders } from '../../../../server/actions'
import {_addNotification,_addNotificationError,} from "../../../../server/util";
class ItemAssign extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            itemLocationResponse:[],
            locations : [],
            schoolID : sessionStorage.getItem('SchoolId'),
            headers : [],
            locationIds : []

        }
        
    }
    _addNotification(event) {
        this._notificationSystem.addNotification({
            title: "Failed",
            message: 'Something went wrong, Please try again later',
            level: 'error',
            position: 'tc',
            autoDismiss: '5',
            uid: 5,

        });
    }
    _addSuccessNotification(message) {
        this._notificationSystem.addNotification({
            title: "Success",
            message: message,
            level: 'success',
            position: 'tc',
            autoDismiss: '5',
            uid: 5,

        });
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        //this.getItemLocations();
        this.setState({loading: true});
        Promise.all([ this.getItemLocations(), this.getLocations()]).then(result=>{
            console.log(result)
            const alacarteItems = result[0].response
            const locations = result[1]._embedded.posLocations
            let headers = [{
                Header: "Item Name", style: { textTransform: 'capitalize'/* , textAlign: 'center' */},width:300, accessor: 'itemName'
            },
            { Header: "All",Cell: props=>this.itemcheckbox(props.original,0)},
            // { Header: "Cafeteria",Cell: props=>this.itemcheckbox(props.original,2),width:250 },
            // { Header: "Break Room",Cell: props=>this.itemcheckbox(props.original,3),width:250 }
            ]
            const locationIds = []
            locations.forEach(item=>{
                locationIds.push(item.locationId)
                const column = {Header: item.location,Cell: props=>this.itemcheckbox(props.original,item.locationId)}
                headers.push(column)
            })
            this.setState({itemLocationResponse:alacarteItems,locations,loading: false,headers,locationIds});
        }).catch((err)=>{
            this._addNotification();
            this.setState({loading: false});
            console.log(err)
        })
       
        
    }

    getLocations = () => {
        //const SchoolId = sessionStorage.getItem('SchoolId');
        return new Promise((resolve,reject)=>{
            get('/posLocations/search/findByMealSchoolSchoolIdAndIsActive?isActive=true&mealSchoolId='+this.state.schoolID+'&access_token=').then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                resolve(response.json())
            }).catch(error=>{
               
                reject(error)
            })
        })

    
    }
    getItemLocations = () => {
        
        return new Promise((resolve,reject)=>{
            get(`/${sessionStorage.getItem('SchoolId')}/itemLocations?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            resolve(response.json())
        }).catch(err=>{
           
            reject(err)
        })
    })
    };
    
    itemcheckbox = (props,type) =>{
        //console.log(props)
        var checked = false, val=type;

        if(props.locationIds){
            
            //select all checking
            if(val===0){
                if(props.locationIds.length === this.state.locationIds.length){
                    checked = true
                }
            }else{
                if(props.locationIds.includes(type)){
                    checked = true
                }
            }
            
        }
        
       
            return (<input type="checkbox" className="radio"  style={{ marginLeft:'auto',marginRight:'auto'}} value={val} checked={checked} onChange={(e)=>this.updateLocationMapping(e,props)}/>)
      
    } 
    updateLocationMapping =(e,props)=>{
        
        var val = parseInt(e.target.value)
        var locations = this.state.itemLocationResponse
        locations.forEach((item)=>{
            if(item.itemId === props.itemId){
                item.isChangedData = true
                var locationids = item.locationIds || []
                if(e.target.checked){
                    if(val!==0){
                        locationids.push(val)
                    }else{
                       // locationids = []
                        locationids = this.state.locationIds
                    }
                    
                }else{
                    if(val!==0){
                        locationids = item.locationIds.filter((i)=> i !== val)
                    }else{
                        locationids = []
                       // locationids = this.state.locationIds
                    }
                    
                }
                item.locationIds = locationids
                
            }
        })
        this.setState({itemLocationResponse:locations})

    }
    saveData=()=>{
        var requestBody = this.state.itemLocationResponse.filter(item=> item.isChangedData )
        //console.log(requestBody)
        requestBody.forEach(item=> delete item.isChangedData)

        if(requestBody.length>0){
            let headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            };
            postWithHeaders(`/${sessionStorage.getItem('SchoolId')}/itemLocations?access_token=`,JSON.stringify(requestBody),headers).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            }).then(data => {
                console.log(data)
               this._addSuccessNotification()
            }).catch(
                (error) => {
                    this._addNotification();
                    console.log(' response', error)
                }
            )
        }
    }
    render() {
        return (<div>
            <NotificationSystem ref="notificationSystem" />
            <div className='sweet-loading'
                style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                <BeatLoader
                    size={20}
                    color={'#ea7066'}
                    loading={this.state.loading}
                />
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-6 col-sm-12 col-xs-12 sectionTitle">
                        <h2>
                            <span></span>
                        </h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="table-responsive">
                            <section className="clearfix">
                                <div className="tab-content">
                                    <div className="media">
                                        <div className="panel panel-primary">
                                            <div className="panel-heading text-left">
                                                <h3 className="panel-title">A la Carte Item Assignment</h3>
                                            </div>
                                            <div className="panel-body">
                                                <ReactTable style={{ textAlign: 'left' }}
                                                    data={this.state.itemLocationResponse}
                                                    columns={this.state.headers}
                                                    defaultPageSize={10}
                                                    className="-striped -highlight"
                                                    noDataText='No data found'
                                                />
                                            </div>
                                            <div className="from-group text-right">
                                                <button type="button" className="btn btn-success btn-xs" onClick={this.saveData}>Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }
}
export default ItemAssign


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Menu/posManagment/itemAssign.jsx